import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyle = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  popOver: {
    zIndex: 40,
    background: 'white',
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    padding: theme.spacing(2),
    position: 'absolute',
    right: 0,
    marginRight: 16,
    width: '25%',
    '&:before': {
      zIndex: 50,
      content: '""',
      position: 'absolute',
      left: -12,
      top: 12,
      borderTop: '12px solid transparent',
      borderRight: '12px solid #fff',
      borderBottom: '12px solid transparent',
    },
  },
  popOver_title: {
    fontSize: '1.1rem',
    color: '#192542',
    fontWeight: 500,
    textAlign: 'left',
  },
  linkContainer: {
    marginTop: 10,
  },
  link: {
    fontSize: '0.85rem',
  },
}));
